<!-- <ngx-ui-loader [fgsSize]="75" bgsColor="black" fgsColor="grey" fgsPosition="center-center"
    fgsType="ball-spin-clockwise"></ngx-ui-loader> -->
<p-toast></p-toast>
<router-outlet></router-outlet>
